export default __webpack_public_path__ + "static/media/person.63123f94.svg";